<template>
	<section class="hp-hero">
		<div class="hp-hero-data">
			<h1
				class="hp-title"
				:class="{ 'hp-title_tr': locale === 'tr' }"
				v-html="$t('home.hero.title', { spanStart: '<span>', spanEnd: '</span>', br: '<br>' })"
			/>
			<p
				class="headline-3 hp-about"
				v-html="$t('home.hero.info', { br: '<br>' })"
			/>

			<div class="hp-btn-wrapper">
				<!--				<NuxtLink-->
				<!--					to="/nft/events"-->
				<!--					class="btn btn-text btn&#45;&#45;border"-->
				<!--				><span class="btn__value">Explore</span></NuxtLink>-->
				<Button
					to="/nft/events"
					size="l"
				>{{ $t('home.hero.explore') }}</Button>
				<!--				<Button to="/guide/" size="l">Btn Guide</Button>-->
				<!--				<NuxtLink :to="{name: 'nft-events'}">NuxtLink object test</NuxtLink><br>-->
				<!--				<MyLink :to="{name: 'nft-events'}">MyLink object test</MyLink><br>-->
				<!--				<MyLink to="/test">MyLink to test</MyLink><br>-->
				<!--				<MyLink to="/test/">MyLink to test/</MyLink><br>-->
				<!--				<MyLink href="/test">MyLink href test</MyLink><br>-->
				<!--				<MyLink href="/test/">MyLink href test/</MyLink><br>-->
			</div>
		</div>
		<div class="hp-img-block">
			<div
				class="hp-img"
				v-for="collection in collections"
				:key="collection"
			>
				<NuxtLink
					:to="collection.url"
					:aria-label="collection.name"
					target="_blank"
					class="hp-img-link"
				>
					<img
						:src="img(collection)"
						:srcset="getSrcset(collection)"
						:alt="`Image of ${collection.name}`"
						class="img img--cover"
					>
				</NuxtLink>
			</div>
		</div>

	</section>
</template>

<script>
export default {
	props: {
		collections: {
			type: Array,
			required: true
		}
	},
	setup() {
		const { locale } = useI18n();

		return {
			locale
		}
	},
	data() {
		return {
			hpImgList: [
				{
					icon: '/assets/images/jpg/mouse-1.jpg',
					href: '',
				},
				{
					icon: '/assets/images/jpg/cat-1.jpg',
					href: '',
				},
				{
					icon: '/assets/images/jpg/mouse-2.jpg',
					href: '',
				},
				{
					icon: '/assets/images/jpg/cat-2.jpg',
					href: '',
				},
				{
					icon: '/assets/images/jpg/mouse-3.jpg',
					href: '',
				},
				{
					icon: '/assets/images/jpg/cat-3.jpg',
					href: '',
				},
				{
					icon: '/assets/images/jpg/mouse-4.jpg',
					href: '',
				},
				{
					icon: '/assets/images/jpg/cat-1.jpg',
					href: '',
				},
				{
					icon: '/assets/images/jpg/mouse-1.jpg',
					href: '',
				},
				{
					icon: '/assets/images/jpg/cat-2.jpg',
					href: '',
				},
				{
					icon: '/assets/images/jpg/mouse-2.jpg',
					href: '',
				},
				{
					icon: '/assets/images/jpg/cat-3.jpg',
					href: '',
				},
				{
					icon: '/assets/images/jpg/mouse-3.jpg',
					href: '',
				},
				{
					icon: '/assets/images/jpg/cat-1.jpg',
					href: '',
				},
				{
					icon: '/assets/images/jpg/mouse-4.jpg',
					href: '',
				},
				{
					icon: '/assets/images/jpg/cat-2.jpg',
					href: '',
				},
				{
					icon: '/assets/images/jpg/mouse-1.jpg',
					href: '',
				},
				{
					icon: '/assets/images/jpg/cat-3.jpg',
					href: '',
				},
				{
					icon: '/assets/images/jpg/mouse-2.jpg',
					href: '',
				},
				{
					icon: '/assets/images/jpg/cat-1.jpg',
					href: '',
				},
			]
		}
	},
	methods: {
		img(item) {
			return `${this.$config.public.HOST_BACKEND}${item?.logo?.url+'/m.webp'}`;
		},
		getSrcset(item) {
			return `${this.$config.public.HOST_BACKEND}${item?.logo?.url+'/m.webp'}, ${this.$config.public.HOST_BACKEND}${item?.logo?.url+'/m2x.webp'} 2x`;
		},
	},
}
</script>
